import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@gan/common/feature-auth';
import { ApplicationVersionService } from '@gan/core/feature-application-version';
import { DarkModeTogglerService } from '@gan/shared/ui-dark-mode-toggler';

import { HeaderComponent } from './modules/header/header.component';
import { LanguageComponent } from '@gan/core/feature-language';
import { OpsNotificationsComponent } from '@gan/common/feature-ops-notifications';
import { SpinnerComponent } from '@gan/common/ui-spinner';
import { NotificationComponent } from '@gan/common/ui-notification';

@Component({
  selector: 'gan-root',
  templateUrl: './app.component.html',
  providers: [DarkModeTogglerService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    OpsNotificationsComponent,
    HeaderComponent,
    RouterOutlet,
    AsyncPipe,
    SpinnerComponent,
    NotificationComponent,
  ],
})
export class AppComponent extends LanguageComponent {
  private applicationVersionService = inject(ApplicationVersionService);
  private authService = inject(AuthService);

  readonly msAccount$ = this.authService.msAccount$;

  constructor() {
    super();

    this.applicationVersionService.init();
  }

  onLogout() {
    this.authService.logout();
  }
}
